// extracted by mini-css-extract-plugin
export var feature = "TwoColumnTextSection-module--feature--4b24a";
export var imageBottom = "TwoColumnTextSection-module--imageBottom--0d9be";
export var imageFeatures = "TwoColumnTextSection-module--imageFeatures--b1cd3";
export var wrapper = "TwoColumnTextSection-module--wrapper--e3e11";
export var wrapperFeature = "TwoColumnTextSection-module--wrapperFeature--4cf9e";